export default __webpack_public_path__ + "static/media/search_banner.36268b2c.svg";